import {
  FETCH_RELATED,
  FETCH_INLINE_RELATED,
  FETCH_SWIMLANE
} from './constants'

export const fetchRelated = {
  request: (id, contentType, currentPhoneId) => ({
    type: FETCH_RELATED['REQUEST'],
    id,
    contentType,
    currentPhoneId
  }),
  success: related => ({ type: FETCH_RELATED['SUCCESS'], related })
}

export const fetchInlineRelated = {
  request: (id, contentType, currentPhoneId) => ({
    type: FETCH_INLINE_RELATED['REQUEST'],
    id,
    contentType,
    currentPhoneId
  }),
  success: inlineRelated => ({
    type: FETCH_INLINE_RELATED['SUCCESS'],
    inlineRelated
  })
}

export const fetchSwimlane = {
  request: () => ({ type: FETCH_SWIMLANE['REQUEST'] }),
  success: swimlanecontent => ({
    type: FETCH_SWIMLANE['SUCCESS'],
    swimlanecontent
  })
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/actions.js